import React, { useRef } from 'react';
import { Story } from '../../../../models/Story';
import { checkImage } from '../../../componentUtils';
import {
	BookmarkContainer,
	BookmarkImg,
	BookmarkImgContainer,
	BookmarkInner,
	BookmarkMeta,
	BookmarkTextContainer,
	BookmarkTitle,
} from '../bookmarkStyles';
import { StoryHelper } from '../../../../models/helpers/Helpers';
import { useHistory } from 'react-router';
import {
	IonIcon,
	IonItemOption,
	IonItemOptions,
	IonItemSliding,
} from '@ionic/react';
import { trash } from 'ionicons/icons';
import {
	BOOKMARK_DEL_STORIES,
	BookmarkReducerAction,
} from '../../../../state/bookmarksSlice';
import { useAppDispatch } from '../../../../state/hooks';
import { createAnimation } from '@ionic/react';

type StoryBookmarkProps = {
	story: Story;
};
const StoryBookmark: React.FC<StoryBookmarkProps> = ({ story }) => {
	const dispatch = useAppDispatch();
	const history = useHistory();

	const gotoStoryPage = () => {
		history.push('/story/' + story.id);
	};

	const container = useRef(null);
	const fadeOutKeyframes = [
		{ offset: 0, opacity: 1 },
		{ offset: 1, opacity: 0 },
	];
	const playAnimation = () => {
		if (container.current !== null) {
			const animation = createAnimation()
				.addElement(container.current)
				.duration(350)
				.keyframes(fadeOutKeyframes)
				.onFinish(removeBookmark);
			animation.play();
		}
	};
	const handleSlide = async (event: any) => {
		const ratio = await event.target.getSlidingRatio();
		if (ratio >= 4) {
			await event.target.open();
			playAnimation();
		}
	};
	const removeBookmark = () => {
		console.log('removing', story.id, story.title);
		dispatch({
			type: BOOKMARK_DEL_STORIES,
			payload: {
				action_id: story.id,
			},
		} as BookmarkReducerAction);
	};

	return (
		<BookmarkContainer ref={container}>
			<IonItemSliding onIonDrag={handleSlide}>
				<BookmarkInner
					onClick={() => {
						gotoStoryPage();
					}}>
					<BookmarkImgContainer>
						<BookmarkImg src={checkImage(story.image)} />
					</BookmarkImgContainer>

					<BookmarkTextContainer>
						<BookmarkTitle>{story.title}</BookmarkTitle>
						<BookmarkMeta>
							{StoryHelper.generateMetaString(story)}
						</BookmarkMeta>
					</BookmarkTextContainer>
				</BookmarkInner>
				<IonItemOptions>
					<IonItemOption
						color="warning"
						expandable
						onClick={() => {
							playAnimation();
						}}>
						<IonIcon slot="icon-only" icon={trash}></IonIcon>
					</IonItemOption>
				</IonItemOptions>
			</IonItemSliding>
		</BookmarkContainer>
	);
};

export default StoryBookmark;
